import React, { ReactElement } from "react";
//#region redux
import { useSelector } from "react-redux";
import { AppState } from "store";
//#endregion
//#region types
import { IconDefinitionConstants } from "utils/constants";
import { TranslationKeys } from "translations";
import { KeyValue } from "models/utilTypes/keyValue";
import { ACTION_SEPARATOR } from "models/propTypes/menuPropTypes";
import { QuotationDetailsProps } from "models/propTypes/quotationPropTypes";
//#endregion
//#region components
import { Grid } from "@mui/material";
import { DetailsTableView, SimpleMessage, Tags } from "components/common";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const QuotationDetails: React.FC<QuotationDetailsProps> = (props) => {
  const { total, tax, currency, referencePersonName, dimensions } = props;

  const { dimensions: dimensionMap } = useSelector((store: AppState) => ({
    dimensions: store.common.dimensions.invoiceDimensions ?? [],
  }));

  const dimensionKeyValues = React.useMemo(() => {
    return dimensions?.length
      ? dimensionMap
          .map((dimensionMapItem) => {
            return dimensionMapItem.value
              .map((dimension) => {
                const invoiceDimension = dimensions.find((d) => d === dimension.id);
                return invoiceDimension ? dimension.name : undefined;
              })
              .filter((d) => d !== undefined);
          })
          .flatMap((d) => d)
          .filter((d) => d !== undefined)
      : [];
  }, [dimensions]);

  const getDetailsList = () => {
    const detailsList: Array<KeyValue<undefined, string | ReactElement> | typeof ACTION_SEPARATOR | undefined> = [
      new KeyValue(
        undefined,
        (
          <SimpleMessage icon={IconDefinitionConstants.WCalculator}>
            <Grid container className={cssExports.highlightText}>
              {LocalizationHelperInstance.getFormattedCurrency(Math.round(total), currency, 2)}
            </Grid>
            <Grid container>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Invoice.OfWhichTax, undefined, {
                tax: LocalizationHelperInstance.getFormattedCurrency(tax, currency, 2),
              })}
            </Grid>
          </SimpleMessage>
        )
      ),
      referencePersonName
        ? new KeyValue(
            undefined,
            (
              <SimpleMessage icon={IconDefinitionConstants.WUser}>
                <Grid className={cssExports.textBlack}>{referencePersonName}</Grid>
              </SimpleMessage>
            )
          )
        : undefined,
      dimensionKeyValues.length ? ACTION_SEPARATOR : undefined,
      dimensionKeyValues.length
        ? new KeyValue(
            undefined,
            (
              <SimpleMessage icon={IconDefinitionConstants.WHashtag}>
                <Grid className={cssExports.textBlack}>
                  {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Tags)}
                </Grid>
              </SimpleMessage>
            )
          )
        : undefined,
      dimensionKeyValues.length ? new KeyValue(undefined, <Tags tags={dimensionKeyValues as string[]} />) : undefined,
    ];

    return detailsList;
  };

  return (
    <DetailsTableView
      title={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.Details)}
      detailsList={getDetailsList()}
    />
  );
};

export default QuotationDetails;
